module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Edifice.02a1a273.webp";